import {IUser} from '@/app/auth/models/AuthModels';

import {IKid} from '../model/AddKidMode';

let kidData: Partial<IKid> = {};

export const saveKidData = (data: Partial<IKid>): void => {
  kidData = {...kidData, ...data};
};

export const getKidData = (profile?: IUser): Partial<IKid> => {
  if (!kidData?.firstName) {
    if (profile?.family?.length > 0) {
      const lastTeenIndex = profile?.family?.length - 1;
      const lastTeen = profile.family[lastTeenIndex];
      return {
        uuid: lastTeen.uuid,
        firstName: lastTeen.first_name,
        lastName: lastTeen.last_name,
        email: lastTeen.email,
        phone: lastTeen.phone,
      };
    }
  }
  return kidData;
};
